import { connect } from 'react-redux'
import { activate } from '../redux/interactionReducer'
import Intro from '../components/Intro'
import { textSelector, activeSelector } from '../redux/selector'

const mapStateToProps = state => ({
  ...textSelector(state),
  isVisible: !activeSelector(state),
  fullscreen: true,
})

const mapDispatchToProps = dispatch => ({
  onClick: () => {
    dispatch(activate())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Intro)
